import { debounce } from 'lodash';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import 'xterm/css/xterm.css';

const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
const { host } = window.location;

export default function TerminalWeb({ detail }) {
  const ref = useRef();

  useEffect(() => {
    let resize, term, socket;
    const { clusterId, serviceIp, hostIp, hostPort, hostUser, passwd, prvKeyName } = detail;

    const doInit = async () => {
      const { Terminal } = await import('xterm');
      const { FitAddon } = await import('xterm-addon-fit');
      const fitAddon = new FitAddon();
      socket = new WebSocket(`${protocol}//${host}/webssh?clusterId=${clusterId}`);
      term = new Terminal();
      term.loadAddon(fitAddon);
      term.open(ref.current);
      term.write('connecting... ');
      socket.onmessage = (e) => term.write(e.data);
      socket.onopen = () => {
        term.write('ok');
        term.focus();
        socket.send(
          JSON.stringify({
            operate: 'connect',
            host: serviceIp || hostIp,
            port: hostPort,
            username: hostUser,
            password: passwd,
            command: 'pwd',
            prvKeyName,
          }),
        );
      };
      socket.onclose = () => {
        setTimeout(() => term.write('\r\n\r\n\x1b[31mConnection is closed.\x1b[0m\r\n'), 200);
      };
      term.onData((data) =>
        socket.send(
          JSON.stringify({
            operate: 'command',
            command: data,
          }),
        ),
      );
      resize = debounce(() => {
        fitAddon.fit();
      }, 200);
      window.addEventListener('resize', resize);
      resize();
    };

    doInit();

    return () => {
      term?.dispose();
      socket?.close();
      if (resize) {
        window.removeEventListener('resize', resize);
      }
    };
  }, [detail]);

  return <Root ref={ref} />;
}

const Root = styled.div`
  .terminal {
    margin-top: 10px;
    padding: 10px;
    height: calc(100vh - 238px);
  }
  .xterm .xterm-viewport {
    border-radius: 6px;
    scrollbar-color: var(--td-scrollbar-color) transparent;
    scrollbar-width: thin;
    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    ::-webkit-scrollbar-thumb {
      border: 2px solid transparent;
      background-clip: content-box;
      background-color: white;
      border-radius: 15px;
    }
    ::-webkit-scrollbar-thumb:vertical:hover,
    ::-webkit-scrollbar-thumb:horizontal:hover {
      background-color: var(--td-scrollbar-hover-color);
    }
  }
`;
